module.exports = __webpack_public_path__ + "static/media/card-gold.3eec8c38.png";